export enum RouteGroupName {
  Base = 'base',
  Certificates = 'certificates',
  Competences = 'competences',
  Gamification = 'gamification',
  News = 'news',
  LegalForms = 'legalForms',
  Profile = 'profile',
  Substitutions = 'substitutions',
  TeamIndicators = 'teamIndicators',
  UsersAdministration = 'usersAdministration'
}
